export default __webpack_public_path__ + "static/media/plain-sticker-wh.761d7d6e.png";